import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list-change",
  "use": "icon-list-change-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-list-change\"><rect width=\"24\" height=\"24\" fill=\"none\" /><g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"><path d=\"M16 5H3m13 7H3m6 7H3m13-3l-3 3l3 3\" /><path d=\"M21 5v12a2 2 0 0 1-2 2h-6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol